const status = { 'deslogado': 0, 'disponivel': 1, 'emPausa': 2, 'indisponivel': 9 }

export default status


// WEBPACK FOOTER //
// ./src/Utils/PabxStatus.js